let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("95awv")).then(() => parcelRequire('gGV5g'));